import React, { useState } from 'react';
import ReactTable from 'react-table'
import ReactTooltip from 'react-tooltip'
import numeral from "numeral";
import moment from "moment";

const TransactionTable = props => {
    const columns = [{
        Header: '#',
        Cell: ({row,original}) => row._index+1,
        maxWidth: 75,
        className:'text-center',
        headerClassName: 'text-center'
    },{
        Header: 'DESKRIPSI',
        accessor: 'referenceId',
        minWidth: 200,
        Cell: ({row,original}) => descCell(original)
    },{
        Header: 'JUMLAH',
        maxWidth: 120,
        accessor: 'debit',
        Cell: ({row,original}) => amountCell(original)
    },{
        Header: 'STATUS',
        maxWidth: 120,
        accessor: 'status',
        Cell: ({row,original}) => statusCell(original)
    },{
        Header: 'WAKTU DIBUAT',
        accessor: 'createdAt',
        headerStyle: { 'whiteSpace': 'unset'},
        maxWidth: 200,
        style: { 'whiteSpace': 'unset'},
        Cell: ({row, original}) => moment(row.createdAt).format("YYYY-MM-DD HH:mm")
    }];

    const descCell = (og) => {
        return (
            <div>
                <div>{og.description}</div>
                <small>KODE TRANSAKSI: {og.referenceId.toUpperCase()}</small>
            </div>
        )
    };

    const amountCell = (og) => {
        return (
            <div>
                Rp. {numeral(Math.abs(og.amount)).format("0,0")}
            </div>
        )
    };

    const statusCell = (og) => {
        let status;
        let amount;

        if (og.status === 'pending') {
            status = (
                <div className="text-warning">
                    <b>pending</b>
                </div>
            )
        } else if (og.status === 'settled') {
            status = (
                <div className="text-success">
                    <b>berhasil</b>
                </div>
            )
        } else if (og.status === 'cancelled') {
            status = (
                <div className="text-muted">
                    cancel
                </div>
            )
        } else if (og.status === 'rejected') {
            status = (
                <div>
                    ditolak
                </div>
            )
        } else if (og.status === 'processing') {
            status = (
                <div className="text-muted">
                    diproses
                </div>
            )
        } else {
            status = (
                <div className="text-muted">
                    {og.status}
                </div>
            )
        }

        return (
            <div>
                {status}
            </div>
        )
    };

    const filterCaseInsensitive = (filter, row) => {
        const id = filter.pivotId || filter.id;
        const content = row[id];
        if (typeof content !== 'undefined') {
            // filter by text in the table or if it's a object, filter by key
            if (typeof content === 'object' && content !== null && content.key) {
                return String(content.key).toLowerCase().indexOf(filter.value.toLowerCase()) > 0;
            } else {
                return String(content).toLowerCase().indexOf(filter.value.toLowerCase()) > 0;
            }
        }
        return true;
    };

    return (
        <div>
            <ReactTable
                data={props.data}
                columns={columns}
                defaultPageSize={10}
                filterable
                loading={props.loading}
                className="-striped -highlight"
                defaultFilterMethod={filterCaseInsensitive}
            />
        </div>
    )
};

export default TransactionTable;
